'use client';

import { storyblokEditable } from '@storyblok/react';
import classNames from 'classnames';

import { Link } from '@/components/link';

import { isLink } from '@/helpers/storyblok/is-link';

import './index.css';

export const HeaderLinks = ({ storyFullSlug, links }) => {
  return (
    <div className="header__links">
      {links.map((item) => {
        const MainEl = isLink(item.link) ? Link : 'div';

        const hasSubLinks = item.subLinks?.length > 0;

        return (
          <div
            key={item._uid}
            {...storyblokEditable(item)}
            className="header__link"
          >
            <MainEl
              link={isLink(item.link) ? item.link : null}
              className={classNames('header__link__main', {
                ['header__link__main--current']:
                  item.link.cached_url === storyFullSlug,
                ['header__link__main--sublinks']: hasSubLinks,
              })}
            >
              {item.title}
            </MainEl>
          </div>
        );
      })}
    </div>
  );
};
